import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, XIcon } from '@integration/alexandria-ui';
import { useRoutes } from 'hooks/routes-hooks';
import { useTranslateByProject } from 'hooks/translation-hooks';
import type { FunctionComponent } from 'react';
import modalActions from 'redux/actions/modalActions';
import {
  ButtonContainer,
  Container,
  Content,
  Header,
  Separator,
} from './styled';
import { contactPhoneSelector, gtmV2Selector } from 'redux/selectors/config';
import { useSynergyAdapterGA } from 'analytics/config/useSynergyAdapterGA';
import { ga4Event } from 'analytics';

const TEST_ID = 'modal-synergy_motor_contact_us';

const MotorContactUsModalContainer: FunctionComponent = () => {
  const t = useTranslateByProject();
  const contactPhone = useSelector(contactPhoneSelector);
  const dispatch = useDispatch();
  const { currentPath } = useRoutes();
  const gtm_v2 = useSelector(gtmV2Selector);
  const { getRoute } = useSynergyAdapterGA();

  useEffect(() => {
    ga4Event({
      eventaction: 'display',
      payload: {
        element_displayed: 'popup',
        element_clicked: 'contact an agent',
        page_name: getRoute(currentPath?.path).page_name,
      },
      gtm_v2,
    });
  }, []);

  const closeModal = () => {
    dispatch(modalActions.hideModalV2());
  };

  const handleCloseModal = () => {
    ga4Event({
      payload: {
        zone: 'popup - contact an agent',
        element_clicked: 'continue | cross',
        page_name: getRoute(currentPath?.path).page_name,
      },
      gtm_v2,
    });
    closeModal();
  };

  const onSecondaryButtonClick = () => {
    document.location.href = `tel:${contactPhone}`;
    ga4Event({
      eventaction: 'call_back',
      payload: {
        zone: 'popup - contact an agent',
        element_clicked: 'call an agent',
        page_name: getRoute(currentPath?.path).page_name,
      },
      gtm_v2,
    });
    closeModal();
  };

  return (
    <Container data-testid={`${TEST_ID}-container`}>
      <Header>
        <h1>{t('synergy-contact_us_modal-title')}</h1>
        <XIcon
          data-testid={`${TEST_ID}-close_btn`}
          onClick={handleCloseModal}
        />
      </Header>
      <Separator />
      <Content>{t('synergy-contact_us_modal-content')}</Content>
      <Separator />
      <ButtonContainer>
        <Button
          dataTestId={`${TEST_ID}-call_agent_btn`}
          variant="OUTLINED"
          onClick={onSecondaryButtonClick}
        >
          {t('synergy-contact_us_modal-call_agent_button')}
        </Button>
        <Button
          dataTestId={`${TEST_ID}-continue_btn`}
          onClick={handleCloseModal}
        >
          {t('synergy-contact_us_modal-continue_button')}
        </Button>
      </ButtonContainer>
    </Container>
  );
};

export default MotorContactUsModalContainer;
